import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { setRemoveRoomUnread } from 'src/redux/slices/staff';
import { useDispatch, useSelector } from 'src/redux/store';
import useAuth from 'src/hooks/useAuth';
import ChatInternoMessagesList from './ChatInternoMessagesList';
import ChatInternoHeaderDetail from './ChatInternoHeaderDetail';
import ChatInternoBottombar from './ChatInternoBottombar';
import SkeletonChatWindow from 'src/components/skeleton/chats/SkeletonChatWindow';
import ChatInternoSkeletonHeader from './components/ChatInternoSkeletonHeader';


export default function ChatInternoWindow() {
  const dispatch = useDispatch();
  const { conversationKey } = useParams();
  const { staff, loadingMsg } = useSelector((state) => state.staff);
  const [selectedMessage, setSelectedMessage] = useState(null);

  const { user } = useAuth()

  useEffect(() => {
    if (conversationKey) {
      dispatch(setRemoveRoomUnread(conversationKey));
    }
  }, [dispatch, conversationKey]);

  return (
    <div className="flex flex-col w-full h-full relative overflow-hidden bg-[#F5F5F5] dark:bg-[#111111]">

      {loadingMsg ? (
        <div className="flex flex-col h-full animate-in fade-in duration-300">
          <ChatInternoSkeletonHeader />
          <div className="flex-1 p-4">
            <SkeletonChatWindow />
          </div>
        </div>
      ) : (
        <div className="flex flex-col h-full animate-in fade-in duration-300">
          <ChatInternoHeaderDetail chat={staff} />
          <div className="flex flex-col flex-1 relative overflow-hidden">
            <ChatInternoMessagesList
              onReply={value => {
                setSelectedMessage(value);
              }}
            />
            <ChatInternoBottombar
              user={user}
              chat={staff}
              selectedMessage={selectedMessage}
              closeReplyMsg={() => {
                setSelectedMessage(null);
              }}
            />
          </div>
        </div>
      )}

    </div>
  );
}
